import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_ENABLE } from "./gql";

const useEnableStack = createDefaultMutationHook(STACK_ENABLE);
export const useBulkEnableStack = createBulkMutationHook(STACK_ENABLE);

export default useEnableStack;
